export const HYPHEN = '-'
export const PERCENTAGE = '%'
export const FILE_SEPARATOR = ':'
export const REQUIRED_MARK = '*'
